<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Prüfung vom
      {{ tools.formatDt(inspection?.dateUtc) }}</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div>Datum: {{ this.tools.formatDt(inspection?.dateUtc) }}</div>
    <div>Maschine: {{ inspection?.machineName }}</div>
    <div>
      Prüfer:
      {{ this.state.getUserDisplayNameAsync(inspection?.createdBy) | async }}
    </div>
    <div>Betriebsstunden: {{ inspection?.operatingHours }}</div>
    <div *ngFor="let group of INSPECTION_GROUPS">
      @if(groupHasElements(group)){
      <div class="group-caption">{{ group.name }}</div>
      <div *ngFor="let element of group.inspectionElements">
        <!--div class="subcaption centered">
          <div>{{ element.name }}:</div>
          <ion-checkbox></ion-checkbox>
          <div>In Ordnung</div>
        </div-->
        @if(inspection?.inspectionResults[element.name] != null){
        <div class="wide">
          <div style="min-width: 250px">
            <div class="subcaption centered">
              {{ element.name }}
              @if(inspection?.inspectionResults[element.name]?.success){<ion-icon
                style="color: rgb(0, 179, 0); margin-left: 5px"
                size="small"
                name="checkmark-circle-outline"
              ></ion-icon
              >}@else {
              <ion-icon
                style="color: rgb(228, 0, 0); margin-left: 5px"
                size="small"
                name="close-circle-outline"
              ></ion-icon>
              }
            </div>
            <div class="centered" style="margin-top: 5px">
              {{ inspection?.inspectionResults[element.name]?.description }}
            </div>
          </div>
        </div>
        }
      </div>
      }
    </div>
    <div style="border-top: 1px solid gray">
      Bemerkungen: {{ inspection?.notes }}
    </div>

    <br />

    <div class="wide">
      <ion-button style="width: 100%" (click)="showInViewer()"
        >Anzeigen</ion-button
      >
      @if(inspection?.approvedBy == null && state.userHasMinType(1)){
      <ion-button style="width: 100%" color="success" (click)="approve()"
        >Bestätigen</ion-button
      >
      } @if (state.userHasMinType(2) || (inspection?.approvedBy == null &&
      state.userHasMinType(1))){
      <ion-button style="width: 100%" (click)="edit()">Bearbeiten</ion-button>
      } @if(state.userHasMinType(1)){
      <ion-button style="width: 100%" color="danger" (click)="delete()"
        >Löschen</ion-button
      >
      }
    </div>
  </div>
</ion-content>
